module.exports = __webpack_public_path__ + "img/labz-tight.aa00ee25.png";